module.exports = __webpack_public_path__ + "d2b5cc5df46962ce9d2841d84db780ad.fbx";